import React from 'react'
import {TextInput} from 'react-native'

type Props = {
  id: string,
  onChangeText: Function,
  placeholder: string,
  placeholderTextColor: string,
  style: object,
  value: string,
}

export const CustomTextInput = (props: Props) => {
  const [text, setText] = React.useState('')

  const onChangeText = (value) => {
    setText(value)
    props.onChangeText(props.id, value)
  }

  return (<TextInput placeholder={props.placeholder} color="black" placeholderTextColor={props.placeholderTextColor} style={props.style} value={text} onChangeText={onChangeText} />)
}

